import get from 'lodash/get'
import set from 'lodash/set'
import request from '../../../request'
import { createAuthorization } from '../../../auth'

export async function createSubscription ({ auth, server, attributes }) {
  const res = await request
    .post(`${server}/notifications/subscriptions`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send(attributes)
  return get(res, 'body', {})
}

export async function deleteSubscription ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/notifications/subscriptions/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}

export async function updateSubscription ({ auth, server, attributes }) {
  const res = await request
    .put(`${server}/notifications/subscriptions`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send(attributes)
  return get(res, 'body', {})
}

export async function getSubscription ({ auth, server, id }) {
  const res = await request
    .get(`${server}/notifications/subscriptions/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', {})
}

export async function getSubscriptions ({
  auth, server, p, pp, type,
}) {
  const query = { p: p || 1, pp: pp || 10 }
  if (type) set(query, 'type', type)
  const res = await request
    .get(`${server}/notifications/subscriptions`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
    .query(query)
  return get(res, 'body', {})
}
